// deps
import React, { memo, useEffect, useState } from "react";

// dls-web-core
import { HalfCard } from "@swiggy-private/dls-web-core/dist/components/HalfCard";

// components
import ExpenseCodeHalfcardContent from "./ExpenseCodeHalfcardContent";

// types
import { IExpenseCodeHalfcardProps } from "./types";
import { isEmpty } from "@swiggy-private/js-utils";

const ExpenseCodeHalfcard = ({
    isOpen,
    fieldValue,
    projectCodeValues,
    requiredFields,
    submitButtonText,
    showDescription,
    onClose,
    handleInputChange,
    onSubmit,
    isRedirectToPlaceOrder,
    analytics,
    expenseCodeDataInCache,
    b2CHalfCardConfig,
    apiCallHandlers,
}: IExpenseCodeHalfcardProps) => {
    const [optionValue, setOptionValue] = useState<string[]>([]);
    const [isProjectCodeSelected, setIsProjectCodeSelected] = useState(false);
    const [isDetailsSubmitted, setIsDetailsSubmitted] = useState(false);
    useEffect(() => {
        if (!isOpen) {
            setIsDetailsSubmitted(false);
        }
    }, [isOpen]);

    return (
        <HalfCard
            isOpen={isOpen}
            onClose={onClose}
            closeOnOverlayClick={!isDetailsSubmitted}
            hideCloseIcon={isDetailsSubmitted}
            variant={!isEmpty(b2CHalfCardConfig) ? "v3" : undefined}
        >
            <ExpenseCodeHalfcardContent
                fieldValue={fieldValue}
                projectCodeValues={projectCodeValues}
                requiredFields={requiredFields}
                handleInputChange={handleInputChange}
                onSubmit={onSubmit}
                optionValue={optionValue}
                setOptionValue={setOptionValue}
                isProjectCodeSelected={isProjectCodeSelected}
                setIsProjectCodeSelected={setIsProjectCodeSelected}
                submitButtonText={submitButtonText}
                showDescription={showDescription}
                setIsDetailsSubmitted={setIsDetailsSubmitted}
                isRedirectToPlaceOrder={isRedirectToPlaceOrder}
                isDetailsSubmitted={isDetailsSubmitted}
                analytics={analytics}
                expenseCodeDataInCache={expenseCodeDataInCache}
                b2CHalfCardConfig={b2CHalfCardConfig}
                apiCallHandlers={apiCallHandlers}
            />
        </HalfCard>
    );
};

export default memo(ExpenseCodeHalfcard);
